module.exports = __webpack_public_path__ + "media/images/apple-touch-icon-180x180-precomposed-7ba85f5d691d7825c0cb8497294156ba.png";